import { Container } from "reactstrap";
import cn from "classnames";
import styles from "./styles.module.scss";
import Caret from "../../public/site-assets/svg/caret.svg";

export const ImageWithVideoBanner = ({
  className,
  content,
  buttons,
  image,
  videoLink,
  videoGalleryClass,
  sectionId,
}) => {
  return (
    <section className={cn(styles.root, className)} id={sectionId}>
      <Container>
        <div className="position-relative p-md-5 p-4 rounded-3 overflow-hidden">
          <div className={cn("imageWrapper", "position-absolute")}>
            {image?.url && (
              <img
                src={image.url}
                alt={image.alt || ""}
                className="card-img rounded-0"
              />
            )}
          </div>
          <div className="position-relative inner">
            <div className="contentWrapper">
              {content && (
                <div
                  data-sourceflow-prop="content"
                  dangerouslySetInnerHTML={{ __html: content }}
                />
              )}
              {videoLink && (
                <a
                  className="fancyBox d-inline-block position-absolute"
                  data-fancybox={videoGalleryClass}
                  href={videoLink}
                  aria-label="Play"
                >
                  <span className="play">
                    <Caret />
                  </span>
                </a>
              )}
            </div>
            {buttons?.length > 0 && (
              <div className="mt-3 d-flex gap-2 flex-wrap">
                {buttons.map(({ id, url, label, className }) => (
                  <a key={id} href={url} className={className}>
                    {label}
                  </a>
                ))}
              </div>
            )}
          </div>
        </div>
      </Container>
    </section> 
  );
};

export default ImageWithVideoBanner;
